import React, { useState, useEffect } from "react";
// import PropTypes from 'prop-types';
import { Box, Form, FormField, Button, Select, Heading } from "grommet";
import { HotelService, GuestService } from "../../services";
import { presentToastSuccess, presentToastErrorContent } from "@shared/Toast";
import { HourInput } from "@shared";
import { useFetchHotel } from "./redux/hooks";
import uniqueTimeZones from "@common/timezones";
import { presentAlertPrompt } from "@shared/Alert";
import {
  GRACE_PERIOD_OPTIONS_LIST,
  BEFORE_GRACE_PERIOD_OPTIONS_LIST,
  getFilteredPropsObject,
} from "@common/utils";
import { useTranslation } from "react-i18next";

const defaultValues = {
  checkinTime: "15:00",
  checkoutTime: "12:00",
  earlyCheckinTime: "12:00",
  lateCheckoutTime: "15:00",
  timezone: "America/New_York",
  gracePeriod: 30,
  beforeGracePeriod: 0,
};

export default function SettingsHotelTimes(props) {
  const { t } = useTranslation();
  const { hotel, fetchHotel } = useFetchHotel();
  const [formValues, setFormValues] = useState(defaultValues);
  const [timezoneOptions, setTimezoneOptions] = useState(uniqueTimeZones);

  useEffect(() => {
    setFormValues({ ...defaultValues, ...hotel });
  }, [hotel]);

  const handleCancel = () => {
    setFormValues({ ...defaultValues, ...hotel });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const request = getFilteredPropsObject(formValues, defaultValues);
    if (hotel.serviceType === "messaging") { delete request.gracePeriod; delete request.beforeGracePeriod; }
    HotelService.updateHotel(request).then(
      (response) => {
        if (response.data.ok) {
          if (
            hotel.checkinTime !== formValues.checkinTime ||
            hotel.checkoutTime !== formValues.checkoutTime
          ) {
            presentAlertPrompt({
              title: "Check-in/out updated",
              message: "Would you like to update future reservations too?",
              onOK: updateFutureBookings,
              onCancel: fetchHotel,
              buttonOKText: "Update",
              buttonOKColor: "status-critical",
            });
          }
          presentToastSuccess("Time Information Updated");
        }
      },
      (error) => {
        presentToastErrorContent(error);
      },
    );
  };

  const updateFutureBookings = () => {
    GuestService.updateFutureBookings().then(
      (response) => {
        if (response.data.success) {
          fetchHotel();
          presentToastSuccess("All future reservations have been updated");
        }
      },
      (error) => {
        fetchHotel();
        presentToastErrorContent(error);
      },
    );
  };

  function handleInputChange({ name, value }) {
    var values = { ...formValues };
    values[name] = value;
    setFormValues(values);
  }

  return (
    <div>
      <Heading level="2">{t("settingsTimes.title")}</Heading>
      <Box width={{ max: "large", width: "100%" }}>
        <Form>
          <FormField label={t("settingsTimes.timezone")}>
            <Select
              name="timezone"
              placeholder={t("common.select")}
              value={formValues.timezone}
              options={timezoneOptions}
              onClose={() => setTimezoneOptions(uniqueTimeZones)}
              onChange={({ value: nextValue }) => {
                setFormValues({ ...formValues, timezone: nextValue });
              }}
              onSearch={(text) => {
                const escapedText = text.replace(
                  /[-\\^$*+?.()|[\]{}]/g,
                  "\\$&",
                );
                const exp = new RegExp(escapedText, "i");
                setTimezoneOptions(uniqueTimeZones.filter((o) => exp.test(o)));
              }}
            />
          </FormField>
          <FormField label={t("settingsTimes.checkinTime")}>
            <HourInput
              name="checkinTime"
              value={formValues.checkinTime}
              onChange={handleInputChange}
              timezone={formValues.timezone}
            />
          </FormField>
          <FormField label={t("settingsTimes.checkoutTime")}>
            <HourInput
              name="checkoutTime"
              value={formValues.checkoutTime}
              onChange={handleInputChange}
              timezone={formValues.timezone}
            />
          </FormField>
          <FormField label={t("settingsTimes.earlyCheckinTime")}>
            <HourInput
              name="earlyCheckinTime"
              value={formValues.earlyCheckinTime}
              onChange={handleInputChange}
              timezone={formValues.timezone}
            />
          </FormField>
          <FormField label={t("settingsTimes.lateCheckoutTime")}>
            <HourInput
              name="lateCheckoutTime"
              value={formValues.lateCheckoutTime}
              onChange={handleInputChange}
              timezone={formValues.timezone}
            />
          </FormField>
          {hotel.serviceType !== "messaging" && hotel.lockType !== "oracode" && (
            <FormField label={t("settingsTimes.gracePeriod")}>
              <Select
                size="medium"
                labelKey="label"
                valueKey={{ key: "value", reduce: true }}
                placeholder={t("common.select")}
                value={formValues.gracePeriod}
                options={GRACE_PERIOD_OPTIONS_LIST}
                onChange={({ value: nextValue }) =>
                  setFormValues({ ...formValues, gracePeriod: nextValue })
                }
              />
            </FormField>
          )}
          {hotel.serviceType !== "messaging" && hotel.lockType !== "oracode" && (
            <FormField label={t("settingsTimes.earlyAccessPeriod")}>
              <Select
                size="medium"
                labelKey="label"
                valueKey={{ key: "value", reduce: true }}
                placeholder={t("common.select")}
                value={formValues.beforeGracePeriod}
                options={BEFORE_GRACE_PERIOD_OPTIONS_LIST}
                onChange={({ value: nextValue }) =>
                  setFormValues({ ...formValues, beforeGracePeriod: nextValue })
                }
              />
            </FormField>
          )}
          <Box direction="row" justify="between" margin={{ top: "medium" }}>
            <Button label={t("settingsTimes.cancel")} onClick={handleCancel} />
            <Button
              type="submit"
              label={t("settingsTimes.update")}
              primary
              onClick={handleOnSubmit}
            />
          </Box>
        </Form>
      </Box>
    </div>
  );
}

SettingsHotelTimes.propTypes = {};
SettingsHotelTimes.defaultProps = {};
